// extracted by mini-css-extract-plugin
export var label = "_gr-0";
export var treatmentCard = "_gr-1";